import clsx from "clsx";
import * as React from "react";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  rounded?: boolean;
  error?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input({ className, rounded, error, ...props }, forwardedRef) {
  return (
    <input
      className={clsx(
        "tw-block tw-w-full tw-bg-white tw-px-3 tw-py-1.5 tw-transition-all",
        // NOTE: Using font-size less than 16px, zooms the input in on ios and doesn't zoom back after blur.
        "tw-border tw-text-base sm:tw-text-sm",
        // `rounded` doubles as "this instance renders inside the redesign-v1 shell" (every caller that
        // passes it is inside `[data-redesign-v1]`, so the `--rd-*`-scoped tokens below always resolve) —
        // swaps the legacy blue-grey text, border and ring for the redesign's neutral colors. This shared
        // `Input` is used by legacy forms, so the base colors stay untouched;
        // only opted-in call sites like the booking form get the redesign look).
        rounded ? "tw-text-foreground tw-ring-ring" : "tw-text-[#4d6b8a] tw-ring-blue-600",
        "tw-outline-none focus-visible:tw-ring-1",
        "disabled:tw-cursor-not-allowed disabled:tw-bg-[#eef1f5]",
        "read-only:tw-cursor-not-allowed read-only:tw-bg-[#eef1f5]",
        "placeholder:tw-text-gray-400",
        { "tw-rounded-md": rounded },
        error ? "tw-border-red-600" : rounded ? "tw-border-border" : "tw-border-[#c2cad8]",
        className,
      )}
      ref={forwardedRef}
      {...props}
    />
  );
});
